<template>
  <ul>
    <li>
      <span>{{ selectedPlan.cartCapacity }} {{ selectedPlan.cartCapacityUnit }}</span>
    </li>
    <li>
      <span>
        {{ $money(selectedPlan.amount) }}{{ $t(`billing.common.per_billing_cycle.${selectedPlan.billing_cycle}`) }}
      </span>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    selectedPlan: Object,
  },
};
</script>
